import ZooPassLocalStateData from "../Data/ZooPassLocalStateData";
import StorageWithExpiryUtility from "../../Utility/StorageWithExpiryUtility";
import ZooPassStepDataUtility from "./ZooPassStepDataUtility";
import { MemberDataDto } from "../Data/MemberDataDto";

export default class ZooPassLocalStateUtility {
    private static LocalStorageStringState : string = 'ZooPassLocalStateData';
    //                                             minutes
    //                                             |    seconds
    //                                             |    |    milliseconds
    //                                             ↓    ↓    ↓
    private static LocalStorageStateTTL : number = 60 * 60 * 1000;  //Use MS directly for sliding ttl

    public static readonly DefaultFormData : MemberDataDto = {
        giftPackageTo: "To the Recipient",
        giftRenewalTo: "To me"
    };
    
    private static DefaultZooPassLocalState : ZooPassLocalStateData = {
        step: 0,
        previousStep: 0,
        step1Value: null,
        step2RenewalPassId: null,
        step2Value: null,
        step3Value: null,
        step4DropdownValue: null,
        step4FinalValue: null,
        step4Value: null,
        step5Value: null,
        step6Value: null,
        step7Value: null,
        step8Value: null,
        step8IdValue: null,
        finalizing: null,
        formData: this.DefaultFormData
    }
    
    public static SetInitialState() : ZooPassLocalStateData {
        return ZooPassLocalStateUtility.SetLocalState(ZooPassLocalStateUtility.DefaultZooPassLocalState);
    }
    
    public static ReadLocalState() : ZooPassLocalStateData | null {
        var data = StorageWithExpiryUtility.ReadLocalStorage<ZooPassLocalStateData>(this.LocalStorageStringState);
        // Account for missing data or missing form data
        if(!data) return this.SetInitialState();
        ZooPassStepDataUtility.FixDataForStep(data);

        // Account for edge cases where form data or form data fields are missing
        if (data.formData == null) {
            data.formData = this.DefaultFormData;
        }
        if (!data.formData.giftPackageTo) {
            data.formData.giftPackageTo = this.DefaultFormData.giftPackageTo;
        }
        if (!data.formData.giftRenewalTo) {
            data.formData.giftRenewalTo = this.DefaultFormData.giftRenewalTo;
        }
        return data;
    }
    
    public static SetLocalState(data : ZooPassLocalStateData) : ZooPassLocalStateData {
        return StorageWithExpiryUtility.SetLocalStorage<ZooPassLocalStateData>(ZooPassLocalStateUtility.LocalStorageStringState, data, ZooPassLocalStateUtility.LocalStorageStateTTL);
    }
}

